import { Typography } from '@mui/material';

interface Props {
  stack: string;
}

export const ErrorStack = ({ stack }: Props) => (
  <>
    <Typography color='inherit' variant='h6'>
      Stack
    </Typography>

    <Typography
      color='inherit'
      component='pre'
      style={{
        maxHeight: 150,
        textAlign: 'left',
        overflow: 'auto',
      }}
    >
      {stack}
    </Typography>
  </>
);
